import Checkbox from '@rio-cloud/rio-uikit/Checkbox';
import Button from 'components/actions/Button';
import { useState } from 'react';

import ErrorMessage from './ErrorMessage';
import { setHeaders } from './utils';
import './UploadSimulationForm_styles.scss';

interface UploadSimulationFormProps {
    domain: string | undefined;
}

/**
 * For future implementations:
 * - how to validate vin - and disable Upload Simulation button
 */
const UploadSimulationForm = ({ domain }: UploadSimulationFormProps) => {
    const [inputVIN, setInputVIN] = useState<string | undefined>(undefined);
    const [inputScenarioId, setInputScenarioId] = useState<string | undefined>(undefined);
    const [inputDriverMode, setInputDriverMode] = useState<boolean>(false);
    // request flow
    const [isRequestSending, setIsRequestSending] = useState<boolean>(false);
    const [isRequestFailed, setIsRequestFailed] = useState<boolean>(false);

    const closeErrorMessage = () => {
        setIsRequestFailed(false);
    };

    const driverMode = inputDriverMode ? 'DRIVER_MODE_IN_SUPERVISED' : 'DRIVER_MODE_OUT_AUTOMATED';

    const uploadSimulation = async () => {
        const url = `${domain}/simulator-adapter-service/api/v2/simulation/${inputVIN}/initialize`;
        setIsRequestFailed(false);
        setIsRequestSending(true);
        try {
            await fetch(url, {
                method: 'POST',
                headers: {
                    ...(await setHeaders()),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    driverMode,
                    id: inputScenarioId,
                }),
            });
        } catch (error) {
            setIsRequestFailed(true);
            console.error(error);
        } finally {
            setIsRequestSending(false);
        }
    };

    return (
        <div className='UploadSimulationForm'>
            {isRequestFailed && (
                <ErrorMessage message='Error while uploading simulation.' onClose={closeErrorMessage} />
            )}
            <div className='UploadForm__form-grid'>
                <div>
                    <label className='UploadForm__field-label' htmlFor='inputScenarioId'>
                        Scenario Id
                    </label>
                    <input
                        onChange={e => setInputScenarioId(e.currentTarget.value)}
                        type='text'
                        className='form-control'
                        id='inputScenarioId'
                        placeholder='e.g. b36d56d4-58a6-405a-a2f3-5bd57ed96d7b'
                    />
                </div>
                <div>
                    <label className='UploadForm__field-label' htmlFor='inputVIN'>
                        Vehicle VIN
                    </label>
                    <input
                        onChange={e => setInputVIN(e.currentTarget.value)}
                        type='text'
                        className='form-control'
                        id='inputVIN'
                        placeholder='e.g. 1HGCM82633A123456'
                    />
                </div>
                <Checkbox
                    checked={inputDriverMode}
                    onChange={e => setInputDriverMode(e.currentTarget.checked)}
                    label='Vehicle Driver Mode IN'
                    className='text-white'
                    id='inputDriverMode'
                />
                <Button
                    data-testid='upload-simulation-scenario-button'
                    disabled={!inputVIN || !inputScenarioId || isRequestSending}
                    className='btn btn-primary'
                    type='submit'
                    onClick={uploadSimulation}
                >
                    <div className='UploadForm__button-content'>
                        {}
                        <span className='rioglyph rioglyph-upload UploadForm__button-icon' />
                        <p>Upload Simulation</p>
                    </div>
                </Button>
            </div>
        </div>
    );
};

export default UploadSimulationForm;
